import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { SocialAuthProvider } from '../../useSocialAuth';
import {
  CONNECT_USER_MUTATION,
  DISCONNECT_USER_MUTATION
} from './useConnectUserAccountMutation.rest';

export const useConnectUserAccountMutation = () => {
  const [connect, { loading: connectLoading, error: connectError }] = useMutation(
    CONNECT_USER_MUTATION
  );

  const [disconnect, { loading: disconnectLoading, error: disconnectError }] = useMutation(
    DISCONNECT_USER_MUTATION
  );

  const handleConnect = useCallback(
    async (provider: SocialAuthProvider, accessToken: string) => {
      const result = await connect({
        variables: {
          input: {
            data: {
              type: 'social_connection',
              attributes: {
                access_token: accessToken,
                provider: provider.toLowerCase()
              }
            }
          }
        }
      });

      return result.data?.connectUser.data.attributes;
    },
    [connect]
  );

  const handleDisconnect = useCallback(
    async (provider: SocialAuthProvider) => {
      const result = await disconnect({
        variables: {
          input: {
            data: {
              type: 'social_connection',
              attributes: {
                provider: provider.toLowerCase()
              }
            }
          }
        }
      });

      return result.data?.disconnectUser.data.attributes;
    },
    [disconnect]
  );

  const connectUser = useCallback(
    (provider: SocialAuthProvider, accessToken: string) => handleConnect(provider, accessToken),
    [handleConnect]
  );

  const disconnectUser = useCallback((provider: SocialAuthProvider) => handleDisconnect(provider), [
    handleDisconnect
  ]);

  return {
    connectUser,
    disconnectUser,
    loading: connectLoading || disconnectLoading,
    error: connectError || disconnectError
  } as const;
};
